import { INewDriverStep2 } from 'features/Drivers/types'
import * as yup from 'yup'

export const driverDocumentsSchema = (): yup.SchemaOf<INewDriverStep2['documents']> => {
  return yup
    .array()
    .of(
      yup.object().shape({
        id: yup.string().optional(),
        category: yup.string().required(),
        file: yup.mixed().optional()
      })
    )
    .optional()
}
